import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../services/common';
import { ExplorationService } from '../main-layout/explorations/exploration.service';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrl: './sub-header.component.scss'
})
export class SubHeaderComponent implements OnInit {
  isDropdownOpen = false;
  options: any;
  selectedOption: any;
  projectList: any;

  constructor(public commonService: CommonService,
    private explorationService: ExplorationService,
    private userservice: UserService, private authService: AuthService) {

  }

  ngOnInit(): void {
    this.refreshProjectsInDropDown();
    this.observeSiteSwitch();
  }

  observeSiteSwitch() {
    this.commonService.refreshProject.subscribe((res: any) => {
      if (res)
        this.refreshProjectsInDropDown()
    })
  }

  refreshProjectsInDropDown() {
    const userProjectsStr = this.commonService.getValueFromLocalStorage("userProjects");

    if (userProjectsStr) {
      this.filterProjectsAndSetDropdown();
    } else {
      if (this.authService.loggedIn()) {
        // if user project list could not be found in local storage then refresh it
        this.userservice.getUserProjects(this.commonService.getLoggedInUserId()).subscribe(res => {
          if (res) {
            this.commonService.setLocalStorageValue("userProjects", JSON.stringify(res?.result));
            this.filterProjectsAndSetDropdown();
          }
        });
      }
    }
  }

  filterProjectsAndSetDropdown() {
    let explorationId = null;
    const selectedExplorationStr = this.commonService.getValueFromLocalStorage('selectedExploration');
    
    if (selectedExplorationStr) {
      try {
        const selectedExploration = JSON.parse(selectedExplorationStr);
        explorationId = selectedExploration?.explorationId ?? selectedExploration?.id ?? selectedExploration?.ExplorationId;
      } catch (e) {
        console.error('Error parsing selectedExploration:', e);
      }
    }

    if (explorationId) {
      this.projectList = this.explorationService.getUserProjectListByExplorationId(explorationId);
    } else {
      this.projectList = this.commonService.getUserPojectListBySiteId(this.commonService?.getCurrentSiteId());
    }

    this.setselectedProjectsInDropDown();
  }

  setselectedProjectsInDropDown() {
    this.options = this.projectList;

    let currentProject: any = null;
    const storedProjectStr = localStorage.getItem('selectedProject');
    if (storedProjectStr) {
      try {
        currentProject = JSON.parse(storedProjectStr);
      } catch (e) { }
    }

    // Verify the currently stored project is actually in the filtered list
    const isProjectInList = currentProject && this.projectList?.some((p: any) => p.id == currentProject.id || p.projectId == currentProject.id);

    if (isProjectInList) {
      this.selectedOption = currentProject?.id;
      this.commonService.updateSelectedProjects(currentProject);
    } else {
      if (this.projectList && this.projectList.length > 0) {
        this.selectedOption = this.projectList[0]?.id;
        this.commonService.updateSelectedProjects(this.projectList[0]);
      } else {
        this.selectedOption = null;
        this.commonService.updateSelectedProjects(null);
      }
    }
  }

  //toggle used to open the dropdown
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Change the selected project in sub header and refresh data for new project
   */
  changeProject() {
    if (this.authService.loggedIn()) {
      var projectData = this.options.find((op: any) => op?.id == this.selectedOption);
      localStorage.setItem('selectedProject', JSON.stringify(projectData).replace("projectId", "id"));
      this.commonService?.updateSelectedProjects(projectData);
    }
  }
}
